"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegStep = void 0;
/**
 * An enumeration.
 */
var RegStep;
(function (RegStep) {
    RegStep[RegStep["CREATE_ACCOUNT"] = 0] = "CREATE_ACCOUNT";
    RegStep[RegStep["PROFILE"] = 1] = "PROFILE";
    RegStep[RegStep["PHOTOS"] = 2] = "PHOTOS";
    RegStep[RegStep["AGEVER"] = 3] = "AGEVER";
    RegStep[RegStep["CONSENT"] = 4] = "CONSENT";
    RegStep[RegStep["PROMOTIONAL"] = 5] = "PROMOTIONAL";
    RegStep[RegStep["PAYMENT"] = 6] = "PAYMENT";
})(RegStep = exports.RegStep || (exports.RegStep = {}));
